import { typeOfRegisterConfirmationEmailSentDialog, typeOfRegisterConfirmationSuccessDialog } from './RegisterConfirmationConstants';
import ConfirmationEmailSentDialog from './Components/ConfirmationEmailSentDialog';
import ConfirmationSuccessDialog from './Components/ConfirmationSuccessDialog';

export default {
  [typeOfRegisterConfirmationEmailSentDialog]: ConfirmationEmailSentDialog,
  [typeOfRegisterConfirmationSuccessDialog]: ConfirmationSuccessDialog,
};
